import { ComponentType, FC } from 'react';
import { AppBarProps, Layout } from 'react-admin';

interface IProp {
    customAppBar?: ComponentType<AppBarProps> | undefined;
}
export const ReactAdminCustomHeader: FC<IProp> = (props) => (
    <Layout
        {...props}
        appBar={props.customAppBar}
        sx={{
            '& main': {
                paddingTop: '35px',
            },
        }}
    />
);

export default ReactAdminCustomHeader;
